export default __webpack_public_path__ + "static/media/image-currency.8862b8ff.jpg";